import { DedicatedDriverPreferencesOutput, UpdateDayIntervalInput } from '@allocab/allocab-dedicated-driver-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';
import { ToastManager } from '../services/toast/utils';
import { t } from '../services/translation/translation';

const deleteDriverPreferences = async (
  id: string,
  input: UpdateDayIntervalInput,
): Promise<DedicatedDriverPreferencesOutput> => {
  return await driverApi.put<UpdateDayIntervalInput, DedicatedDriverPreferencesOutput>(
    `/v1/dedicated-driver-preferences/driver/${id}/remove`,
    input,
  );
};

export const useDeleteDriverPreferences = (id: string) =>
  useMutation<DedicatedDriverPreferencesOutput, unknown, UpdateDayIntervalInput, UpdateDayIntervalInput>({
    mutationFn: input => deleteDriverPreferences(id, input),
    onMutate: input => input,
    onSuccess: preferences => {
      ToastManager.show({ message: t('driver-preferences.delete'), severity: 'success' });
      queryClient.invalidateQueries(queryKeys.user.fetchDriversPreferencesData());
      queryClient.setQueryData(queryKeys.user.fetchDrivePreferencesById(id), preferences);
    },
  });
